<template>
  <v-row>
    <v-col v-if="item">
      <p class="sub-header1 text-tcdc-green bold">{{ item[`branch_name_${lang}`] ? item[`branch_name_${lang}`]:'' }}</p>
      <p class="vhtml" v-if="item[`detail_${lang}`]" v-html="item[`detail_${lang}`]"></p>
      <p class="sub-header2 text-tcdc-green bold">Contact</p>
      <p class="vhtml" v-if="item.contact" v-html="item.contact[`description_${lang}`]"></p>
      <p class="sub-header2 text-tcdc-green bold">Opening Hours</p>
      <p class="vhtml" v-if="item.location" v-html="item.location.opening_hours_detail"></p>
      <Divider v-if="showDivider" />
    </v-col>
  </v-row>
</template>

<script>
import Divider from "../../components/dividers/Divider";
import { mapState } from 'vuex';

export default {
  props: {
    item: {
      required: true
    },
    showDivider: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Divider
  },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang
    })
  }
};
</script>

<style></style>
